import { Route } from 'vue-router';

export const ContactRoute: Record<string, Partial<Route>> = {
  CONTACT: {
    path: 'contacts',
    name: 'contacts'
  },
  CONTACT_ESTATE_STAKEHOLDERS: {
    path: 'contacts/estate-stakeholders',
    name: 'estate-stakeholders'
  },
  CONTACT_PROFESSIONALS: {
    path: 'contacts/professionals',
    name: 'professionals'
  },
  CONTACT_FAMILY_TREE: {
    path: 'contacts/family-tree',
    name: 'family-tree'
  }
};
